import { t } from "i18next";
import { NoData } from "neetoui";

const ErrorMessage = () => (
  <div className="flex h-screen w-full items-center justify-center">
    <NoData title={t("errors.someThingWentWrong")} />
  </div>
);

export default ErrorMessage;
